"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086FF",
  d: "M20.4051 4.9972C20.4051 5.53996 20.4051 6.10534 20.4267 6.69333L20.4277 6.7554C20.5143 12.3356 20.6318 19.9124 11.7742 23.1118C11.7093 23.1344 11.6227 23.157 11.5362 23.157C11.4645 23.157 11.4077 23.1415 11.3411 23.1233C11.3273 23.1196 11.3131 23.1157 11.2983 23.1118C2.41155 19.9019 2.55902 12.2858 2.66717 6.70053L2.66731 6.69333C2.68894 6.08272 2.68894 5.51735 2.68894 4.97459C2.68894 4.5449 3.01341 4.20568 3.42441 4.20568C6.5826 4.20568 9.00533 3.25585 11.0171 1.2205C11.2983 0.926501 11.7742 0.926501 12.0554 1.2205C14.0671 3.25585 16.4898 4.20568 19.6696 4.22829C20.0806 4.22829 20.4051 4.56752 20.4051 4.9972ZM10.5195 13.1168L14.0887 9.38531C14.3699 9.0687 14.8458 9.0687 15.1271 9.36269C15.4083 9.6793 15.4083 10.1768 15.1271 10.4708L11.0171 14.7677C10.8873 14.926 10.6926 14.9938 10.4979 14.9938C10.3032 14.9938 10.1302 14.926 9.97876 14.7677L7.92377 12.6193C7.64256 12.3026 7.64256 11.8051 7.92377 11.5111C8.22661 11.2171 8.70251 11.2171 8.98371 11.5111L10.5195 13.1168Z"
})), 'GuaranteeFilled', {
  viewBox: '0 0 24 24'
});

exports.default = _default;